export default "__VITE_ASSET__CApylJhr__"